module.exports = __webpack_public_path__ + "muted.335c6ebd.png";